export default __webpack_public_path__ + "static/media/activity-report.ef4e713c.webp";